import React, { useState } from 'react';
import {
  Box,
  Typography,
  Alert,
  Checkbox,
  FormControlLabel,
  Button,
  Paper,
  Stack,
  useTheme,
  alpha,
} from '@mui/material';
import {
  WarningAmber,
  DeleteForever,
} from '@mui/icons-material';

export function DeleteAccount() {
  const theme = useTheme();
  const [understood, setUnderstood] = useState(false);

  return (
    <Box sx={{ maxWidth: '600px' }}>
      <Typography variant="h4" fontWeight={800} color="error" gutterBottom>
        Delete Account
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        We're sorry to see you go. Please review the consequences of account deletion below.
      </Typography>

      <Alert 
        severity="error"
        icon={<WarningAmber fontSize="large" />}
        sx={{ 
          mb: 4, 
          borderRadius: '16px',
          bgcolor: alpha(theme.palette.error.main, 0.05),
          border: '1px solid',
          borderColor: alpha(theme.palette.error.main, 0.2),
          '& .MuiAlert-message': { fontSize: '1rem', fontWeight: 500 }
        }}
      >
        Deleting your account will permanently remove all of your course progress, certificates, messages, and social connections. This action is <strong>completely irrecoverable</strong>.
      </Alert>

      <Box sx={{ p: 1, mb: 4 }}>
        <FormControlLabel
          control={
            <Checkbox 
              checked={understood} 
              onChange={(e) => setUnderstood(e.target.checked)}
              color="error"
            />
          }
          label={
            <Typography variant="body2" fontWeight={600} color="text.primary">
              I understand that deleting my account is permanent and my data will be lost forever.
            </Typography>
          }
        />
      </Box>

      <Button 
        variant="contained" 
        color="error"
        size="large"
        disabled={!understood}
        startIcon={<DeleteForever />}
        sx={{ 
          px: 6, 
          py: 1.5, 
          borderRadius: '50px', 
          fontWeight: 800,
          boxShadow: understood ? '0 8px 25px rgba(211, 47, 47, 0.3)' : 'none',
          '&.Mui-disabled': { bgcolor: alpha(theme.palette.error.main, 0.1) }
        }}
      >
        Permanently Delete My Account
      </Button>
    </Box>
  );
}
